import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedService } from '../../services/feed.service';
import { LoginService } from 'src/app/core/services/login.service';
import { PostnewJob } from 'src/app/modules/profile/services/job-section.service';
import { ToastService } from 'src/app/core/toast.service';

@Component({
  selector: 'app-add-employee-type',
  templateUrl: './add-employee-type.component.html',
  styleUrls: ['./add-employee-type.component.scss']
})
export class AddEmployeeTypeComponent implements OnInit {
 employeeTypeForm: FormGroup;
  employeeTypeId: string | null = null;
  employeeTypeName: any;
  constructor(private route: ActivatedRoute, private fb: FormBuilder, private router: Router, public feedService: FeedService, public loginService: LoginService,private jobService: PostnewJob, private toast: ToastService) {
    this.employeeTypeForm = this.fb.group({
      employee_type_name: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['employeeTypeName']) {
        this.employeeTypeForm.patchValue({ employee_type_name: params['employeeTypeName'] });
      }
    });
    this.route.paramMap.subscribe(params => {
      this.employeeTypeId = params.get('id');
      if (this.employeeTypeId) {
        this.loadCategoryDetails();
      }
    });

  }
  loadCategoryDetails() { }

  onSubmit(): void {

    if (this.employeeTypeForm.invalid) {
      this.employeeTypeForm.markAllAsTouched();  // This will show error messages
      return;  
    }

    const loginData = this.loginService.getLoginData();


    if (!loginData) {
      console.error('Login data is not available');
      return;
    }
    const employeeTypeData = {
      ...this.employeeTypeForm.value,
      created_by: loginData.type,
      created_by_user_id: loginData.id
    };
    const response = this.employeeTypeId ? this.jobService.editEmployeeType(this.employeeTypeId, employeeTypeData.employee_type_name) :  this.jobService.addEmployeeType(employeeTypeData);
    // const response = this.jobService.addEmployeeType(employeeData);
    response
      .then(response => {
        this.router.navigate(['/profile/list-employee-type']);
        this.toast.openSnackBar(this.employeeTypeId ? 'Employee Type Updated successfully':'Employee Type Added successfully'); 
      })
      .catch(error => {
        console.error("Error occurred:", error);
      });
  }


  onCancel(): void {
    this.router.navigate(['/profile/list-employee-type']);
  }
}